var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-page-body-content" },
    [
      _vm.backendError
        ? [
            _c(
              "p",
              { staticClass: "headline text-xs-center red--text" },
              [
                _c("v-icon", { attrs: { color: "red", size: "50px" } }, [
                  _vm._v("error_outline")
                ]),
                _c("br"),
                _vm._v(
                  "\n        Server Error: " +
                    _vm._s(_vm.backendError.message) +
                    "\n      "
                )
              ],
              1
            )
          ]
        : [
            _c(
              "v-container",
              { staticClass: "px-0 py-0", attrs: { "grid-list-sm": "" } },
              [
                !_vm.loading && _vm.channel !== "ch_kiosk"
                  ? _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-card",
                              [
                                _c(
                                  "v-card-text",
                                  { staticClass: "py-1" },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "mx-0 my-0 pt-2 px-0",
                                            attrs: { xs2: "" }
                                          },
                                          [
                                            _c("v-switch", {
                                              attrs: {
                                                label: _vm.bookingInfoString,
                                                value: "",
                                                "input-value": "true",
                                                color: "teal accent-2"
                                              },
                                              model: {
                                                value: _vm.bookingEditMode,
                                                callback: function($$v) {
                                                  _vm.bookingEditMode = $$v
                                                },
                                                expression: "bookingEditMode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "mx-0 my-0 py-3 px-0",
                                            attrs: { xs10: "" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "body-2" },
                                              [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      color: "red darken-3",
                                                      "text-color": "white"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          id:
                                                            "bookie-available-seats"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.availableSeat
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " Out of \n                        "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          id: "bookie-capacity"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.totalCapacity
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " Seats Available\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      color: "blue darken-2",
                                                      "text-color": "white"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.selectedSeatsNames
                                                            .length
                                                        ) +
                                                        " Out of " +
                                                        _vm._s(_vm.numSeats) +
                                                        " Seats Selected.\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      color: "green darken-1",
                                                      "text-color": "white"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "body-2",
                                                        attrs: {
                                                          id:
                                                            "bookie-selected-seats",
                                                          "data-seat_ids":
                                                            _vm.selectedSeatsIds,
                                                          "data-Seat_names":
                                                            _vm.selectedSeatsNames
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Selected seats: " +
                                                            _vm._s(
                                                              _vm.selectedSeatsNames
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.channel === "ch_kiosk"
                  ? _c("div", {
                      attrs: {
                        hidden: "",
                        id: "bookie-selected-seats",
                        "data-seat_ids": _vm.selectedSeatsIds,
                        "data-Seat_names": _vm.selectedSeatsNames
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.loading
                  ? _c(
                      "v-card",
                      [
                        _c(
                          "v-card-text",
                          {
                            ref: "bookingCanvasContainer",
                            staticClass: "py-0 px-0",
                            staticStyle: { "overflow-x": "scroll" }
                          },
                          [
                            _c(
                              "div",
                              {
                                class: {
                                  "c-canvas": _vm.channel !== "ch_kiosk",
                                  "c-canvas-kiosk": _vm.channel === "ch_kiosk"
                                },
                                style: {
                                  width: _vm.canvasWidth + "px",
                                  height: _vm.canvasHeight + "px",
                                  zoom: _vm.canvasZoom + "%"
                                }
                              },
                              [
                                _vm._l(_vm.slotsUnbound, function(slot, index) {
                                  return _c("c-seat", {
                                    key: "st" + index,
                                    staticStyle: { position: "absolute" },
                                    attrs: {
                                      "my-seat": slot,
                                      "booking-mode": true,
                                      reserved: slot.reserved,
                                      booked: slot.booked,
                                      "reposition-booking": slot.reposition,
                                      "reposition-hint": slot.repositionHint
                                    },
                                    on: {
                                      "seat-selected": function($event) {
                                        _vm.selectSeat($event, index)
                                      },
                                      "bulk-move-destination": function(
                                        $event
                                      ) {
                                        _vm.setBulkMoveDestination(
                                          $event,
                                          index
                                        )
                                      },
                                      "enable-edit-mode": function($event) {
                                        _vm.enableEditMode($event, index)
                                      }
                                    }
                                  })
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.uiComponentsUnbound, function(
                                  uiComponent,
                                  index
                                ) {
                                  return [
                                    uiComponent.type === "SCREEN"
                                      ? _c("c-screen", {
                                          key: "sc" + index,
                                          attrs: {
                                            "my-screen": uiComponent,
                                            "booking-mode": true
                                          }
                                        })
                                      : uiComponent.type === "WALL"
                                        ? _c("c-wall", {
                                            key: "wl" + index,
                                            attrs: {
                                              "my-wall": uiComponent,
                                              "booking-mode": true
                                            }
                                          })
                                        : uiComponent.type === "RAILING"
                                          ? _c("c-railing", {
                                              key: "rl" + index,
                                              attrs: {
                                                "my-railing": uiComponent,
                                                "booking-mode": true
                                              }
                                            })
                                          : uiComponent.type === "TEXT"
                                            ? _c("c-ui-text", {
                                                key: "txt" + index,
                                                staticStyle: {
                                                  position: "absolute"
                                                },
                                                attrs: {
                                                  "my-text": uiComponent,
                                                  "booking-mode": true
                                                }
                                              })
                                            : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            !_vm.loading && _vm.channel !== "ch_kiosk"
              ? _c("c-legend")
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b75ff5ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b75ff5ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/Booking.vue
// module id = null
// module chunks = 